
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punetomumbaionewaycab() {



    const cardData =
    {
        keyword: 'Pune to Mumbai One Way Cab',
        heading: 'Skyline Cabs: Pune to Mumbai One Way Cab',
        headingDescription: 'Skyline Cabs provides reliable and affordable Pune to Mumbai One Way Cab services. Whether you’re traveling for a business meeting, leisure, or any other purpose, our one-way cab service offers a convenient and cost-effective solution. With experienced drivers, well-maintained vehicles, and a commitment to punctuality, Skyline Cabs ensures a smooth and hassle-free journey from Pune to Mumbai. Book your one-way ride today and enjoy a comfortable travel experience!',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Marine Drive",
        "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
    },
    {
        "title": "Elephanta Caves",
        "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
        "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
    },
    {
        "title": "Juhu Beach",
        "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],


"services": [
    {
      "name": "Pune to Mumbai One Way Cab",
      "description": "Skyline Cabs offers one-way cab services from Pune to Mumbai for a smooth and hassle-free journey. Whether you’re traveling for business or leisure, we ensure comfort, punctuality, and affordable pricing. Our fleet of well-maintained vehicles, including sedans and SUVs, ensures a convenient travel experience tailored to your needs."
    },
    {
      "name": "Pune to Mumbai Taxi One Way",
      "description": "Looking for a one-way taxi ride from Pune to Mumbai? Skyline Cabs provides flexible options, ensuring your trip is comfortable and on time. Choose from our wide range of vehicles including sedans and luxury cars, perfect for solo travelers or groups. Book your one-way taxi today for an easy and pleasant ride."
    },
    {
      "name": "Pune Mumbai Cab One Way",
      "description": "Skyline Cabs specializes in one-way cab services from Pune to Mumbai, offering reliable and affordable options. Our professional drivers ensure a comfortable journey, whether you’re heading to a business meeting, airport, or leisure trip. Choose from various vehicles including the Ertiga, Innova, and more."
    },
    {
      "name": "One Way Cab Pune to Mumbai Airport",
      "description": "Skyline Cabs offers convenient one-way cab services from Pune to Mumbai Airport. Whether you're flying out or arriving, our professional drivers ensure a smooth and timely transfer to or from the airport. We provide various vehicle options to suit your preferences, from budget-friendly sedans to premium cars."
    },
    {
      "name": "One Way Mumbai to Pune",
      "description": "If you're traveling from Mumbai to Pune, Skyline Cabs offers one-way rides with exceptional comfort and punctuality. Whether it's a business trip, personal travel, or an airport transfer, we guarantee a smooth and stress-free ride. Book your one-way taxi service with us today!"
    },
    {
      "name": "One Way Pune to Mumbai",
      "description": "Travel one-way from Pune to Mumbai with Skyline Cabs. Our fleet includes a range of vehicles such as the Ertiga, Innova, and Swift Dzire, ensuring you have a comfortable and timely ride. Perfect for a single-day trip or one-way airport transfer, book with us for reliable service."
    },
    {
      "name": "Pune to Mumbai One Way Innova Crysta Taxi Cab",
      "description": "Experience luxury and comfort with Skyline Cabs’ one-way Innova Crysta taxi service from Pune to Mumbai. Ideal for business or family travel, the Innova Crysta offers ample space, comfort, and a premium ride. Ensure you arrive on time and in style, with a driver who knows the best routes."
    },
    {
      "name": "Pune to Mumbai Airport One Way Cab",
      "description": "Skyline Cabs offers affordable and efficient one-way cab services from Pune to Mumbai Airport. Our drivers are well-versed in the best routes to ensure timely arrivals, while our vehicles provide comfort and style. Whether you're catching a flight or heading home, we make your journey stress-free."
    },
    {
      "name": "Pune to Mumbai One Way Sedan Taxi Cab",
      "description": "Travel in comfort with a one-way sedan taxi from Pune to Mumbai with Skyline Cabs. Whether you're going to a business meeting, leisure trip, or airport, our sedans provide a comfortable and efficient travel experience. Book now for a reliable and professional one-way taxi ride."
    },
    {
      "name": "One Way Cab Booking Pune to Mumbai",
      "description": "Booking a one-way cab from Pune to Mumbai with Skyline Cabs is easy and quick. We offer online booking options for your convenience, ensuring you get the best prices and reliable service. Our fleet is diverse, including everything from budget-friendly vehicles to luxury cars."
    },
    {
      "name": "Pune to Mumbai Cab Round Trip",
      "description": "Skyline Cabs offers round-trip cab services between Pune and Mumbai, providing comfort, convenience, and punctuality. Whether you need to travel back and forth for business or leisure, we ensure a seamless experience. Book your round-trip ride today and enjoy flexible travel plans."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "For a comfortable, family-friendly ride from Pune to Mumbai, book an Ertiga cab with Skyline Cabs. Offering spacious seating and air-conditioning, the Ertiga is the perfect choice for small groups or families traveling one way. Enjoy a smooth and enjoyable ride at an affordable price."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Skyline Cabs offers the Innova for a premium one-way ride from Pune to Mumbai. Whether you are heading to a corporate meeting or need extra space for your luggage, the Innova provides comfort and luxury for a relaxed journey. Book your one-way ride today!"
    },
    {
      "name": "Pune To Mumbai Taxi Services",
      "description": "Skyline Cabs provides excellent one-way and round-trip taxi services from Pune to Mumbai. Whether it's for a quick trip, airport transfer, or a business visit, we ensure timely, comfortable, and hassle-free journeys. Our fleet includes everything from compact sedans to luxurious cars."
    },
    {
      "name": "One Way Cab",
      "description": "Skyline Cabs offers reliable one-way cab services for travelers heading to and from Pune and Mumbai. Book your cab today for an easy, affordable, and comfortable journey, whether it's for an airport transfer, business, or leisure travel."
    },
    {
      "name": "Pune to Mumbai Taxi Service One Way Cab Service",
      "description": "Looking for a one-way taxi service from Pune to Mumbai? Skyline Cabs offers prompt, reliable, and comfortable rides with a fleet of well-maintained vehicles. Whether it's an urgent trip or a planned visit, we ensure that you reach your destination on time and in comfort."
    },
    {
      "name": "Pune to Mumbai Airport Cab Fare",
      "description": "Skyline Cabs provides competitive and transparent pricing for one-way rides from Pune to Mumbai Airport. We offer various vehicle options to suit your budget and ensure you travel in comfort. Get in touch with us to receive an accurate fare estimate based on your requirements."
    },
    {
      "name": "Cheapest Cab from Pune to Mumbai Airport",
      "description": "Looking for affordable yet reliable cab services from Pune to Mumbai Airport? Skyline Cabs offers the cheapest fares for one-way trips without compromising on quality or comfort. Book your affordable airport transfer today and enjoy a smooth ride."
    },
    {
      "name": "Best Cab Service Pune to Mumbai",
      "description": "Skyline Cabs is known for providing the best taxi services between Pune and Mumbai. Our fleet is well-maintained, and our drivers are experienced, ensuring you a comfortable and safe journey. Book your one-way trip or round trip today for a top-notch travel experience."
    },
    {
      "name": "Pune to Mumbai One Way Skyline Cabs",
      "description": "Choose Skyline Cabs for your one-way journey from Pune to Mumbai. Our commitment to customer satisfaction and reliable service ensures you have a comfortable trip. Book online or via phone for a personalized experience with our fleet of modern vehicles."
    },
    {
      "name": "Pune to Mumbai One Way Ertiga Cab",
      "description": "For a budget-friendly one-way ride from Pune to Mumbai, choose Skyline Cabs’ Ertiga. This vehicle is ideal for families or small groups, offering plenty of space and comfort. Book your Ertiga cab today for a smooth and enjoyable journey."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Skyline Cabs offers efficient and comfortable cab services for your one-way journey from Pune to Mumbai Airport. Our fleet includes a variety of vehicles, from affordable sedans to luxury cars, ensuring you travel in comfort and style. Book your airport transfer now!"
    }
  ],

  "tableData": [
    ["Pune to Mumbai One Way Cab", "-Pune to Mumbai Taxi One Way"],
    ["Pune to Mumbai Cab One Way", "-One Way Cab Pune to Mumbai Airport"],
    ["One Way Mumbai to Pune", "-One Way Pune to Mumbai"],
    ["Pune to Mumbai One Way Innova Crysta Taxi Cab", "-Pune to Mumbai Airport One Way Cab"],
    ["Pune to Mumbai One Way Sedan Taxi Cab", "-One Way Cab Booking Pune to Mumbai"],
    ["Pune to Mumbai Cab Round Trip", "-Pune to Mumbai Ertiga Cab"],
    ["Pune to Mumbai Innova Cab", "-Pune To Mumbai Taxi Services"],
    ["One Way Cab", "-Pune to Mumbai Taxi Service One Way Cab Service"],
    ["Pune to Mumbai Airport Cab Fare", "-Cheapest Cab from Pune to Mumbai Airport"],
    ["Best Cab Service Pune to Mumbai", "-Pune to Mumbai One Way Skyline Cabs"],
    ["Pune to Mumbai One Way Ertiga Cab", "-Pune to Mumbai Airport Cab"]
  ],

  whychoose: [
    {
        "WhyChooseheading": "Reliable Pune to Mumbai One Way Cab Service",
        "WhyChoosedescription": "Skyline Cabs specializes in one way cab services from Pune to Mumbai, offering timely pickups and smooth drop-offs without the need to pay for a round trip. Whether you're heading to a meeting, visiting family, or catching a flight, we make sure you arrive on time and without hassle."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Equipped Vehicles",
        "WhyChoosedescription": "Our fleet includes a wide selection of sedans, SUVs, and premium vehicles—each maintained to the highest standards. Enjoy a smooth, relaxing ride with features like air-conditioning, plush seating, and ample space for luggage, making your one-way trip as comfortable as possible."
    },
    {
        "WhyChooseheading": "Experienced Drivers Who Know the Route",
        "WhyChoosedescription": "With years of experience navigating the Pune to Mumbai route, our drivers ensure a safe and efficient journey. They're courteous, well-trained, and committed to giving you a stress-free travel experience—even during peak hours or on unfamiliar roads."
    },
    {
        "WhyChooseheading": "Affordable One Way Fares with No Hidden Costs",
        "WhyChoosedescription": "At Skyline Cabs, you only pay for what you use. Our one way cab service from Pune to Mumbai is priced transparently with no extra charges or last-minute surprises. Know your fare upfront and travel with confidence."
    },
    {
        "WhyChooseheading": "24/7 Availability for One Way Trips",
        "WhyChoosedescription": "Need to travel early in the morning or late at night? We’ve got you covered. Skyline Cabs offers round-the-clock service, allowing you to book a Pune to Mumbai one way cab at any hour that fits your schedule."
    },
    {
        "WhyChooseheading": "Clean and Hygienic Vehicles for Your Comfort",
        "WhyChoosedescription": "We take cleanliness seriously. All our vehicles are sanitized before every trip, regularly serviced, and inspected to ensure they are in excellent condition. Your comfort and safety are our top priorities throughout the entire journey."
    },
    {
        "WhyChooseheading": "Quick and Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking a Pune to Mumbai one way cab is simple and convenient. Use our website, mobile app, or just give us a call—whichever you prefer. You’ll receive instant confirmation and all the ride details straight to your phone or email."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel with Verified Drivers",
        "WhyChoosedescription": "All Skyline drivers are background-checked and trained in safe driving practices. With GPS-enabled cabs and live ride tracking, you and your loved ones can stay informed and feel secure throughout the trip from Pune to Mumbai."
    }
]





    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a Pune to Mumbai One Way cab with Skyline Cabs?',
            answer:
                'Booking a one-way cab from Pune to Mumbai with Skyline Cabs is simple. You can make your reservation via our website, mobile app, or by calling our customer support team for assistance.',
        },
        {
            id: 2,
            question: 'What types of vehicles does Skyline Cabs offer for a Pune to Mumbai One Way trip?',
            answer:
                'We offer a variety of vehicle options for your one-way trip from Pune to Mumbai, including sedans, SUVs, and luxury cars. All our vehicles are well-maintained for a comfortable and safe ride.',
        },
        {
            id: 3,
            question: 'Are the drivers of Skyline Cabs experienced for long-distance one-way trips?',
            answer:
                'Yes, our drivers are well-trained and experienced with long-distance routes like Pune to Mumbai. They ensure a smooth, safe, and punctual journey for your one-way ride.',
        },
        {
            id: 4,
            question: 'What payment options are available for my Pune to Mumbai One Way ride?',
            answer:
                'Skyline Cabs offers several payment options, including cash, credit/debit cards, UPI, and secure online payments via our app for your convenience.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip with Skyline Cabs instead of a one-way trip?',
            answer:
                'Yes, you can book a round-trip as well. Just mention your return details during the booking process, and we will arrange the return journey from Mumbai to Pune for you.',
        },
        {
            id: 6,
            question: 'Are there any additional charges for waiting time or detours?',
            answer:
                'Skyline Cabs follows transparent pricing. Any additional charges for waiting time or detours will be communicated to you in advance, with no hidden fees.',
        },
        {
            id: 7,
            question: 'Is the one-way ride from Pune to Mumbai flexible for stops?',
            answer:
                'Yes, if you wish to make stops along the way, simply let us know during the booking, and we can accommodate your requests, subject to additional charges.',
        },
        {
            id: 8,
            question: 'What’s the luggage allowance for a Pune to Mumbai One Way cab?',
            answer:
                'Our vehicles are equipped to accommodate standard luggage. For larger baggage or special requests, please inform us at the time of booking, and we will make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Do you offer corporate bookings for Pune to Mumbai One Way trips?',
            answer:
                'Yes, we offer corporate services for one-way trips between Pune and Mumbai. We can provide customized solutions for business meetings, conferences, and team outings.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Pune to Mumbai One Way journey?',
            answer:
                'Skyline Cabs is known for its punctuality, experienced drivers, well-maintained vehicles, and affordable prices. We provide a smooth, reliable, and comfortable ride for your one-way journey from Pune to Mumbai.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Sameer Gupta",
            rating: 5,
            review: "I used Skyline Cabs for a one-way trip from Pune to Mumbai, and I’m extremely satisfied. The car was clean, the driver was polite, and the ride was comfortable. I’ll definitely use them for future trips!"
        },
        {
            name: "Miss. Rhea Kapoor",
            rating: 4,
            review: "The one-way trip to Mumbai was smooth and hassle-free. The driver was professional, and the vehicle was in excellent condition. The only thing I would suggest is to improve the real-time tracking feature in the app."
        },
    ];
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai One Way Cab",
  "image": "https://skylinecabs.com/assets/images/pune-to-mumbai-one-way-cab.jpg",
  "description": "Book Pune to Mumbai one way cab with Skyline Cabs for convenient, affordable, and comfortable travel. Choose from AC sedans, SUVs, and get professional drivers for a hassle-free ride.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7294"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1250",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-to-mumbai-one-way-cab"
  }
};



      
    
      


    return (
        <div>
<Helmet>
  <title>Pune to Mumbai One Way Cab | Affordable Travel | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai one way cab with Skyline Cabs for convenient, affordable, and comfortable travel. Choose from AC sedans, SUVs, and get professional drivers for a hassle-free ride." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai One Way Cab, One Way Taxi Pune to Mumbai, Affordable Cab Pune to Mumbai, AC Cab Pune to Mumbai One Way, Sedan Cab One Way Pune, SUV One Way Taxi Pune, Pune to Mumbai Drop Taxi, Skyline Cabs Pune to Mumbai, 24/7 One Way Cab Service, Pune Mumbai Travel One Side, Verified One Way Cabs Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/4.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaionewaycab;